import type { DetailModalLabels } from 'voyager';

import { useTranslations } from '@lang';

export default function useDetailModalLabels(): DetailModalLabels {
  const { t } = useTranslations();

  return {
    close: t('room.upgrade.close'),
    perNight: t('room.night'),
    totalDue: t('room.upgrade.totalDue'),
    reserve: t('common.reserve'),
    termsHeading: t('app.termsAndConditions'),
    previousImage: t('aria.previousImage'),
    nextImage: t('aria.nextImage'),
    goToImage: (position: number, total: number) => t('aria.goToImage', { position, total }),
  };
}
